// extracted by mini-css-extract-plugin
module.exports = {"root":"evCl9GJrb5A3sBWZWXWk"};